var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentityGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m101,13.36C51.5,13.36,11.23,53.63,11.23,103.13s40.27,89.77,89.77,89.77,89.77-40.27,89.77-89.77S150.5,13.36,101,13.36Zm58,136.66v-1c0-23.25-18.92-42.17-42.17-42.17h-31.67c-23.25,0-42.17,18.92-42.17,42.17v1c-10.28-12.77-16.46-28.98-16.46-46.62,0-41.06,33.4-74.46,74.46-74.46s74.46,33.4,74.46,74.46c0,17.63-6.17,33.85-16.46,46.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m101,43.64c-16.38,0-29.71,13.33-29.71,29.71,0,2.08.22,4.17.65,6.21.52,2.43,1.35,4.8,2.46,7.04,2.82,5.65,7.48,10.35,13.1,13.22,2.22,1.14,4.59,1.99,7.03,2.53,2.13.47,4.3.71,6.46.71s4.32-.24,6.45-.71c2.44-.54,4.8-1.39,7.03-2.53,5.63-2.87,10.29-7.57,13.11-13.22,1.12-2.24,1.94-4.6,2.46-7.04.43-2.04.65-4.13.65-6.21,0-16.38-13.33-29.71-29.71-29.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentityGray);
export default __webpack_public_path__ + "static/media/identity-gray.955b7614050e8b1f110a079c62e3bf0a.svg";
export { ForwardRef as ReactComponent };